<template>
  <div id="container" v-loading.fullscreen="loading">
    <div class="all_item">
      <h3 class="full_layout">{{$t('base.allSellers')}}</h3>
    </div>
    <f-z-f class="notfind" title="" v-if="nofind"/>
    <sellers-list class="full_layout full_list" :list="list" :type="sellerTyle" v-if="!nofind"/>
    <list-pagination class="full_layout"  :TotalCount="TotalCount" :ps="ps" @ps='pageSize' @pi='pageIndex' v-if="!nofind"/>
  </div>
</template>

<script>
/* 模拟假数据 */
import demo from '@/api/demo'

import { getInfo } from "@/api/public";
import SellersList from '@/components/list/sellers'
import ListPagination from '@/components/listpagination'
export default {
  name: 'index',
  components: {SellersList,ListPagination},
  data () {
    return {
      sn:'',
      userInfo:'',
      ps: 60, //pagesize
      pi: 1, //pageindex
      TotalCount: 0,
      list:'',
      sellerTyle:"full",
      nofind:false,
      loading: false,
    }
  },
  mounted() {
    var that=this
    this.$root.$on("newSearch", val => {
      that.sn = val || null;
        window.localStorage.setItem("sn", that.sn)
    })
  },
  created() {
    this.userInfo=getInfo();
    this.GetStoresList();
  },beforeRouteUpdate(to, from, next) {
    let that = this;
    this.GetStoresList();
    next()
  },
  methods: {
    // 获取商铺列表
    GetStoresList(){
      let that=this
      that.loading=true
      let st=window.localStorage.getItem('st');
      if(st==2){
        that.sn=window.localStorage.getItem('sn');
      }
      let data={'StoreName':that.sn,'IsRecommend':'','MemberId':'','PageIndex':that.pi,'PageSize':that.ps}
       if (that.userInfo != null) {
        data.MemberId=that.userInfo.MappingUserId
       }
       //console.log(data.MemberId)
      this.$get(this.$interface.GetStoresList,data).then(res=>{
        if(res.result!=0){
          that.TotalCount=res.count
          that.list=res.data
          that.loading=false
        }else{
          that.loading=true
        }
      })
    },

    // 每页几条
    pageSize(val) {
      this.ps = val
      this.GetStoresList();

    },
    // 页码
    pageIndex(val) {
      this.pi = val
      this.GetStoresList();
    },
  } 
} 
</script>

<style scoped>
.all_item{
  border-top:1px solid #F0F0F0;
}
.all_item h3{
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/seller/list.vue